
import { Suspense } from "react";
import MainLayout from "@/components/layout/MainLayout";
import AdvancedVoiceInterface from "@/components/voice-agent/AdvancedVoiceInterface";
import LoadingSkeleton from "@/components/voice-agent/LoadingSkeleton";
import PageSEO from "@/components/seo/PageSEO";

const VoiceAgent = () => {
  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://metrocalma.org/app"
    },
    {
      position: 2,
      name: "Agente de Voz",
      item: "https://metrocalma.org/agente-voz"
    }
  ];

  const structuredData = {
    "@type": "Service",
    "name": "Agente de Voz metrocalma",
    "description": "Assistente virtual inteligente para conversas terapêuticas e suporte emocional através de reconhecimento de voz avançado.",
    "applicationCategory": "HealthApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "BRL"
    },
    "featureList": [
      "Reconhecimento de voz em tempo real",
      "Análise emocional da fala",
      "Conversas terapêuticas personalizadas",
      "Suporte 24/7"
    ]
  };

  const handleTranscriptionComplete = (text: string, confidence: any) => {
    console.log('Transcription completed:', text, confidence);
  };

  return (
    <MainLayout>
      <PageSEO 
        title="Agente de Voz - metrocalma | Terapia por Voz com IA Avançada"
        description="Converse com nosso agente de voz inteligente para suporte emocional personalizado. Tecnologia avançada de reconhecimento de voz e análise emocional em tempo real."
        canonicalUrl="https://metrocalma.org/agente-voz"
        keywords="agente voz, terapia voz, IA conversacional, suporte emocional, reconhecimento voz, assistente virtual"
        pageName="Agente de Voz"
        pageType="Service"
        structuredData={structuredData}
        breadcrumbs={breadcrumbs}
      />
      
      <Suspense fallback={<LoadingSkeleton />}>
        <AdvancedVoiceInterface onTranscriptionComplete={handleTranscriptionComplete} />
      </Suspense>
    </MainLayout>
  );
};

export default VoiceAgent;
